<ion-item [formGroup]="parent">
  <ion-input
    [formControlName]="question.key"
    [attr.disabled]="question.disabled"
    [attr.readonly]="question.readonly"
    [id]="question.key"
    [type]="question.type"
  >
  </ion-input>
</ion-item>
